export default class BanksFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.textSearch = "";
  }
  fillData(data) {
    this.textSearch = data.textSearch;
  }
}
